module.exports = __webpack_public_path__ + "static/media/enjoyment.974033c6.svg";